import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=44f82a80&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=44f82a80&prod&lang=scss&scoped=true"
import style1 from "./delivery.vue?vue&type=style&index=1&id=44f82a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f82a80",
  null
  
)

export default component.exports